<div
  class="grid snap-x snap-mandatory grid-flow-col grid-cols-[repeat(auto-fit,_minmax(224px,_224px))] gap-3.5 overflow-x-scroll md:grid-flow-row md:overflow-x-auto"
>
  @for (review of reviews(); track review.externalReviewId) {
    <div class="flex w-[224px] snap-center flex-col rounded-lg border border-solid border-steel-20 p-6">
      <rma-external-review class="cursor-pointer" [reviewInput]="review" (click)="onShowDialog(review)" />
    </div>
  }

  @if (loading()) {
    @for (x of [].constructor(3); track $index) {
      <rma-skeleton-block class="h-60" />
    }
  }
</div>
